var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronCircleLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9999,
    cy: 15.9997,
    r: 6.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 3.33301C9.01325 3.33301 3.33325 9.01301 3.33325 15.9997C3.33325 22.9863 9.01325 28.6663 15.9999 28.6663C22.9866 28.6663 28.6666 22.9863 28.6666 15.9997C28.6666 9.01301 22.9866 3.33301 15.9999 3.33301ZM18.2799 19.0531C18.7999 19.5731 18.7999 20.4263 18.2799 20.9463C18.0133 21.1996 17.6799 21.333 17.3333 21.333C16.9866 21.333 16.6532 21.1996 16.3866 20.9463L12.3866 16.9463C11.8666 16.4263 11.8666 15.5731 12.3866 15.0531L16.3866 11.0531C16.9066 10.5331 17.7599 10.5331 18.2799 11.0531C18.7999 11.5731 18.7999 12.4263 18.2799 12.9463L15.2132 15.9997L18.2799 19.0531Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCircleLeft);
export default __webpack_public_path__ + "static/media/chevron-circle-left.9c3df44f.svg";
export { ForwardRef as ReactComponent };